
let Searchable = require('@/mixins/Searchable')
let Paginator = require('@/mixins/Paginator')

module.exports = {

    mixins: [Paginator, Searchable],

    data() {
        return {
            permissions: [],
            displayPermission: null,
        }
    },

    mounted() {
        this.fetchPermissions()
    },

    methods: {

        requestPaginate() {
            this.fetchPermissions();
        },

        fetchPermissions() {
            axios.get(`/management/permissions?page=${this.paginator.current_page}&per_page=${this.paginator.per_page}&query=${this.searchKey}&paginate`).then(response => {
                this.paginator = response.data
                this.permissions = this.paginator.data;
                if (this.permissions.length) this.displayPermission = this.permissions[0];
            })
        },

        updatePermission(permission) {
            this.displayPermission = permission;
            this.openModal('update-permission');
        },

        deletePermission(permission) {
            this.displayPermission = permission;
            this.openModal('delete-permission');
        },
    },

}
